import React from 'react'
import { Ticket } from '../Component/TicketCreate/Ticket'
import Sidebar from '../Component/Sidebar/Sidebar'
import { Table2 } from 'lucide-react'
import EmployeeTicketTable from '../Component/TicketDetails/EmployeeTicket'
export const Ticketpage = () => {
  return (
    <div>
          <Sidebar>
            <Ticket/>
        </Sidebar>
    </div>
  )
}
